import Helpers from '@Apis/helpers';
import Decimal from 'decimal.js';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { DEFAULT_CUR_ROUND_OFF, QUANTITY } from '@Apis/constants';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import { notification } from 'antd';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import FormHelpers from '../../../../helpers/FormHelpers';

export const INITIAL_STATE = (user) => {
  const documentUINames = documentUINamesConstant(user);

  return {
    data: [
      {
        key: uuidv4(),
        product_sku_name: '',
        product_sku_id: '',
        packing_slip_line_id: null,
        tenant_product_id: '',
        quantity: '',
        uom_info: '',
        batchConsumptionMethod: '',
        product_batches: [],
        consumption_quantity: '',
        lineCustomFields: [],
      },
    ],
    packingSlipId: null,
    orderDate: dayjs(),
    psTypeValue: documentUINames.salesOrderUIName,
    isFromSalesOrder: true,
    attachments: [],
    description: '',
    textAreaHeight: 2,
    showAddCustomer: true,
    showNewCustomerModal: false,
    customVoucherNumber: '',
    allStock: true,
    visibleColumns: {
      PRODUCT: {
        label: 'Product',
        visible: true,
        disabled: true,
      },
      ORDER_QUANTITY: {
        label: 'Order Quantity',
        visible: true,
        disabled: true,
      },
      PACKED_QUANTITY: {
        label: 'Packed Quantity',
        visible: true,
        disabled: true,
      },
    },
    isUserReadyForCF: false,
    cfSalesOrderDoc: [],
    cfSalesOrderLine: [],
    tenantDepartmentId: null,
    coNumber: '',
    sendWhatsappNotification: false,
    selectedCustomer: null,
    selectedCustomerInfo: null,
    accountManager: null,
    formSubmitted: false,
    soData: null,
    selectedSoValue: null,
    selectedCustomerSo: null,
    vehicleNumber: '',
    documentUINames,
    updateDocumentReason: '',
    shipFromAddress: null,
    shipToAddress: null,
  };
};

export const isDataValid = (state, props, errors) => {
  const {
    orderDate, selectedCustomer, coNumber, data, allStock, cfConsumptionOrderDoc,
  } = state;
  let isDataValid = true;

  if (!orderDate || !selectedCustomer || !coNumber || !CustomFieldHelpers.isCfValid(cfConsumptionOrderDoc)) {
    isDataValid = false;
  }

  for (let i = 0; i < data?.length; i++) {
    if (Number(data[i]?.consumption_quantity) <= 0 || !CustomFieldHelpers.isCfValid(data[i]?.lineCustomFields)) {
      isDataValid = false;
    }

    if (!['SERVICE', 'BUNDLE', 'NON_STORABLE'].includes(data[i]?.product_sku_info?.product_type)) {
      if (Number(Number(Helpers.getValueTotalInObject(data[i]?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty') || 0) - (Number(data[i]?.consumption_quantity || 0) + Number(data[i]?.packed_free_quantity || '0'))) < 0) {
        isDataValid = false;
      }
    } else if (data[i]?.product_sku_info?.product_type === 'BUNDLE') {
      const arr = [];
      for (let j = 0; j < data[i]?.bundle_products?.length; j++) {
        const bundleProductBatches = data[i]?.bundle_products?.[j]?.product_batches;
        const qty = Helpers.getValueTotalInObject(bundleProductBatches?.filter((item) => item?.batch_in_use), 'available_qty');
        arr.push((qty || 0) / (data[i]?.bundle_products[i]?.quantity / (data[i]?.quantity || 1)));
      }

      if ((data[i]?.product_sku_info?.product_type === 'STORABLE') && (Math.min(...arr) - (Number(data[i]?.consumption_quantity || 0) + Number(data[i]?.packed_free_quantity || 0))) < 0) {
        isDataValid = false;
      }
    }
  }

  const { docLevelError, lineLevelError } = errors;

  if (!!docLevelError?.length || !!lineLevelError?.length) {
    isDataValid = false;
  }
  return isDataValid;
};

export const clearReservationsByLine = (lineKey) => {
  const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
  const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));
  Object.keys(staticReservationCopy)?.forEach((batchKey) => {
    if (staticReservationCopy?.[batchKey]?.[lineKey] !== undefined) {
      delete staticReservationCopy?.[batchKey]?.[lineKey];
    }
  });
  sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
};

// export const getBatches = (oldBatches, quantity, lineUomInfo, productUomInfo, barcodeBatchId, lineKey, resetNotRequired, allStock, cBatchId, cBatchQty) => {
//   const batches = oldBatches?.map((batch) => ({ ...batch }));
//   let remainingQty = quantity;
//   const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
//   const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));

//   const clearLineReservations = () => {
//     if (cBatchId) {
//       // Delete only the specified batchKey for the given lineKey if cBatchId is present
//       delete staticReservationCopy?.[cBatchId]?.[lineKey];
//     } else {
//       Object.keys(staticReservationCopy)?.forEach((batchKey) => (
//         delete staticReservationCopy?.[batchKey]?.[lineKey]
//       ));
//     }
//   };
//   clearLineReservations();
//   const getBatchReservations = (batchId) => {
//     let total = 0;
//     if (staticReservationCopy?.hasOwnProperty(Number(batchId)) && Object.keys(staticReservationCopy[batchId])?.length > 0) {
//       Object.keys(staticReservationCopy[batchId])?.forEach((item) => {
//         total += Number(staticReservationCopy[batchId][item]);
//       });
//     }
//     return {
//       total,
//       reservations: staticReservationCopy[batchId],
//     };
//   };
//   const addBatchReservation = (batchId, qty) => {
//     if (staticReservationCopy?.hasOwnProperty(batchId)) {
//       if (staticReservationCopy[batchId]?.hasOwnProperty(lineKey)) staticReservationCopy[batchId][lineKey] += qty;
//       else staticReservationCopy[batchId][lineKey] = qty;
//     } else {
//       staticReservationCopy[batchId] = {
//         [lineKey]: qty,
//       };
//     }
//   };

//   for (let i = 0; i < batches?.length; i++) {
//     const batchReservations = getBatchReservations(batches[i]?.batch_id);
//     batches[i]._reserved = batchReservations;
//     if (!resetNotRequired) {
//       batches[i].batch_in_use = batchReservations?.batch_in_use || true;
//     }
//     if (cBatchId) {
//       batches[i].consumed_qty = batches[i].consumed_qty || 0;
//     } else {
//       batches[i].consumed_qty = 0;
//     }
//   }

//   if (cBatchId) {
//     // Allocate the given cBatchQty to the corresponding batch
//     for (let i = 0; i < batches?.length; i++) {
//       if (batches[i]?.batch_id === cBatchId) {
//         // const avlQty = ((Number(batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total)) / lineUomInfo?.ratio) * productUomInfo?.ratio;
//         const avlQty = QUANTITY(FormHelpers.uomConversion(productUomInfo, lineUomInfo, batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total), lineUomInfo?.precision);
//         const allocatedQty = Math.min(Number(cBatchQty), avlQty);
//         batches[i].consumed_qty = allocatedQty;
//         batches[i].batch_in_use = true;
//         remainingQty -= allocatedQty;
//         addBatchReservation(batches[i]?.batch_id, allocatedQty);
//         break; // Exit the loop since we have allocated the quantity
//       }
//     }
//   } else if (barcodeBatchId) {
//     for (let i = 0; i < batches?.length; i++) {
//       const avlQty = ((Number(batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total)) / lineUomInfo?.ratio) * productUomInfo?.ratio;
//       if (batches[i]?.batch_id === barcodeBatchId) {
//         batches[i].consumed_qty = avlQty > remainingQty ? remainingQty : avlQty;
//         batches[i].batch_in_use = true;
//         remainingQty -= batches[i]?.consumed_qty;
//         addBatchReservation(batches[i]?.batch_id, batches[i].consumed_qty);
//       }
//     }
//   } else {
//     for (let i = 0; i < batches?.length; i++) {
//       // Skip the batch if allStock is true and the batch is marked as a rejected batch
//       if (allStock && batches[i]?.is_rejected_batch) continue;
//       // const avlQty = ((Number(batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total)) / lineUomInfo?.ratio) * productUomInfo?.ratio;
//       const avlQty = QUANTITY(FormHelpers.uomConversion(productUomInfo, lineUomInfo, batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total), lineUomInfo?.precision);

//       if (batches?.[i]?.batch_in_use) {
//         if (remainingQty > 0 && Number(batches[i]?.consumed_qty || '0') < avlQty) {
//           batches[i].consumed_qty = avlQty > remainingQty ? remainingQty : avlQty;
//           batches[i].batch_in_use = true;
//           remainingQty -= batches[i]?.consumed_qty;
//           addBatchReservation(batches[i]?.batch_id, batches[i]?.consumed_qty);
//         } else {
//           batches[i].consumed_qty = 0;
//           batches[i].batch_in_use = true;
//           remainingQty -= batches[i]?.consumed_qty;
//         }
//       }
//     }
//   }
//   sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
//   return batches?.map((item) => ({ ...item, _reserved: getBatchReservations(item?.batch_id) }));
// };
export const getBatches = (oldBatches, quantity, lineUomInfo, productUomInfo, barcodeBatchId, lineKey, resetNotRequired, allStock, cBatchId, cBatchQty) => {
  const batches = oldBatches?.map((batch) => ({ ...batch }));
  let remainingQty = new Decimal(quantity);
  const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
  const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));

  const clearLineReservations = () => {
    if (cBatchId) {
      // Delete only the specified batchKey for the given lineKey if cBatchId is present
      delete staticReservationCopy?.[cBatchId]?.[lineKey];
    } else {
      Object.keys(staticReservationCopy)?.forEach((batchKey) => (
        delete staticReservationCopy?.[batchKey]?.[lineKey]
      ));
    }
  };
  clearLineReservations();
  const getBatchReservations = (batchId) => {
    let total = new Decimal(0);
    if (staticReservationCopy?.hasOwnProperty(Number(batchId)) && Object.keys(staticReservationCopy[batchId])?.length > 0) {
      Object.keys(staticReservationCopy[batchId])?.forEach((item) => {
        total = total.plus(new Decimal(staticReservationCopy[batchId][item]));
      });
    }
    return {
      total: total.toNumber(),
      reservations: staticReservationCopy[batchId],
    };
  };

  const addBatchReservation = (batchId, qty) => {
    const qtyDecimal = new Decimal(qty);
    if (staticReservationCopy?.hasOwnProperty(batchId)) {
      if (staticReservationCopy[batchId]?.hasOwnProperty(lineKey)) {
        staticReservationCopy[batchId][lineKey] = new Decimal(staticReservationCopy[batchId][lineKey]).plus(qtyDecimal).toNumber();
      } else {
        staticReservationCopy[batchId][lineKey] = qtyDecimal.toNumber();
      }
    } else {
      staticReservationCopy[batchId] = {
        [lineKey]: qtyDecimal.toNumber(),
      };
    }
  };

  for (let i = 0; i < batches?.length; i++) {
    const batchReservations = getBatchReservations(batches[i]?.batch_id);
    batches[i]._reserved = batchReservations;
    if (!resetNotRequired) {
      batches[i].batch_in_use = batchReservations?.batch_in_use || true;
    }
    batches[i].consumed_qty = cBatchId ? batches[i].consumed_qty || 0 : 0;
  }

  if (cBatchId) {
    // Allocate the given cBatchQty to the corresponding batch
    for (let i = 0; i < batches?.length; i++) {
      if (batches[i]?.batch_id === cBatchId) {
        // const avlQty = ((Number(batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total)) / lineUomInfo?.ratio) * productUomInfo?.ratio;
        const convertedQty = new Decimal(
          FormHelpers.uomConversion(productUomInfo, lineUomInfo, batches?.[i]?.available_qty) || 0
        );

        const reservedQty = new Decimal(batches?.[i]?._reserved?.total || 0);

        const avlQty = QUANTITY(convertedQty.minus(reservedQty).toNumber(), lineUomInfo?.precision);

        const allocatedQty = Decimal.min(new Decimal(cBatchQty || 0), new Decimal(avlQty));
        batches[i].consumed_qty = allocatedQty.toNumber();
        batches[i].batch_in_use = true;
        remainingQty = remainingQty.minus(allocatedQty);
        addBatchReservation(batches[i]?.batch_id, allocatedQty);
        break; // Exit the loop since we have allocated the quantity
      }
    }
  } else if (barcodeBatchId) {
    for (let i = 0; i < batches?.length; i++) {
      const avlQty = QUANTITY(
        new Decimal(batches?.[i]?.available_qty || 0)
          .minus(new Decimal(batches?.[i]?._reserved?.total || 0))
          .div(new Decimal(lineUomInfo?.ratio || 1))
          .times(new Decimal(productUomInfo?.ratio || 1))
          .toNumber(),
        lineUomInfo?.precision
      );
      if (batches[i]?.batch_id === barcodeBatchId) {
        const allocatedQty = Decimal.min(avlQty, remainingQty);
        batches[i].consumed_qty = allocatedQty.toNumber();
        batches[i].batch_in_use = true;
        remainingQty = remainingQty.minus(allocatedQty);
        addBatchReservation(batches[i]?.batch_id, allocatedQty);
      }
    }
  } else {
    for (let i = 0; i < batches?.length; i++) {
      // Skip the batch if allStock is true and the batch is marked as a rejected batch
      if (allStock && batches[i]?.is_rejected_batch) continue;
      // const avlQty = ((Number(batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total)) / lineUomInfo?.ratio) * productUomInfo?.ratio;
      const convertedQty = new Decimal(
        FormHelpers.uomConversion(productUomInfo, lineUomInfo, batches?.[i]?.available_qty) || 0
      );

      const reservedQty = new Decimal(batches?.[i]?._reserved?.total || 0);

      const adjustedQty = QUANTITY(convertedQty.minus(reservedQty).toNumber(), lineUomInfo?.precision);

      if (batches?.[i]?.batch_in_use) {
        const consumedQty = new Decimal(batches[i]?.consumed_qty || 0);
        if (remainingQty.greaterThan(0) && consumedQty.lessThan(adjustedQty)) {
          const allocatedQty = Decimal.min(adjustedQty, remainingQty);
          batches[i].consumed_qty = allocatedQty.toNumber();
          batches[i].batch_in_use = true;
          remainingQty = remainingQty.minus(allocatedQty);
          addBatchReservation(batches[i]?.batch_id, allocatedQty);
        } else {
          batches[i].consumed_qty = 0;
          batches[i].batch_in_use = true;
          remainingQty = remainingQty.minus(batches[i]?.consumed_qty || 0);
        }
      }
    }
  }
  sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
  return batches?.map((item) => ({ ...item, _reserved: getBatchReservations(item?.batch_id) }));
};

export const handleDeleteHelper = (state, props, key, setState) => {
  const { data, cfConsumptionOrderLine } = state;
  const { selectedSO } = props;
  if (selectedSO && data?.length === 1) {
    notification.open({
      message: 'Error: At least one product must remain. This product cannot be removed.',
      duration: 4,
      type: 'error',
      placement: 'top',
    });
    return;
  }
  clearReservationsByLine(key);
  if (data?.length === 1) {
    setState({
      data: [{
        key: uuidv4(),
        product_sku_name: '',
        product_sku_id: '',
        quantity: '',
        uom_info: '',
        batchConsumptionMethod: '',
        product_batches: [],
        consumption_quantity: '',
        lineCustomFields: cfConsumptionOrderLine,
      }],
    });
  } else {
    const copyData = data.filter((item) => item.key !== key);
    setState({ data: copyData });
  }
};

export const toggleBatchHelper = (state, props, record, adjustmentRow, setState) => {
  const { data } = state;
  for (let i = 0; i < data?.length; i++) {
    if (data[i]?.key === adjustmentRow?.key) {
      const rowBatches = data[i]?.product_batches;
      for (let j = 0; j < rowBatches?.length; j++) {
        if (rowBatches[j]?.batch_id === record?.batch_id && rowBatches[j]?.is_reserved === record?.is_reserved) {
          rowBatches[j].batch_in_use = !rowBatches[j]?.batch_in_use;
          // data[i].consumption_quantity -= rowBatches[j].consumed_qty;
          const consumedQty = new Decimal(rowBatches[j]?.consumed_qty || 0);
          const consumptionQty = new Decimal(data[i]?.consumption_quantity || 0);
          data[i].consumption_quantity = consumptionQty.minus(consumedQty).toNumber();
          rowBatches[j].consumed_qty = 0;
          clearReservationsByLine(data[i]?.key);
        }
      }
      const consumedBatches = rowBatches?.filter((i) => i?.consumed_qty > 0 && i?.batch_in_use)?.map((i) => ({
        sp: i?.selling_price,
        quantity: i?.consumed_qty,
      }));

      break;
    }
  }
  setState({ data });
};

export const toggleBatchInnerHelper = (state, props, record, adjustmentRow, setState) => {
  const { data } = state;
  const copyData = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < copyData?.length; i++) {
    const newData = copyData[i];
    if (newData?.key === adjustmentRow?.parentKey) {
      newData.consumption_quantity = 0;
      const bundleProducts = newData?.bundle_products;
      for (let j = 0; j < bundleProducts?.length; j++) {
        const rowBatches = bundleProducts[j]?.product_batches;
        for (let k = 0; k < rowBatches?.length; k++) {
          if (rowBatches[k]?.batch_id === record?.batch_id) {
            rowBatches[k].batch_in_use = !rowBatches[k]?.batch_in_use;
          }
          rowBatches[k].consumed_qty = 0;
        }
      }
    }
  }
  setState({ data: copyData });
};

export const handleProductChangeValueHelper = (state, props, value, key, setState) => {
  const { data } = state;
  const copyData = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < copyData?.length; i++) {
    if (copyData[i].key === key) {
      const copyDataItem = copyData[i];
      copyDataItem.product_sku_name = value;
      copyData[i] = copyDataItem;
    }
  }
  setState({ data: copyData });
};

export const getDataSource = (dataSource) => {
  const data = JSON.parse(JSON.stringify(dataSource));
  return [...data.filter((item) => item?.product_sku_id), ...data.filter((item) => !item?.product_sku_id)];
};

const createDefaultRow = ({
  dataLine, product, tenantSku, productData,
}) => {
  const copyDataItem = dataLine;
  const parentKey = uuidv4();
  const pBatches = getBatches(product?.product_batches, 1, product?.uom_info, product?.product_info?.uom_info, tenantSku?.barcode_batch_id, parentKey);
  copyDataItem.key = parentKey;
  copyDataItem.tenant_product_id = product?.tenant_product_id;
  copyDataItem.packing_slip_line_id = product?.order_line_id;
  copyDataItem.product_type = product?.product_type;
  copyDataItem.product_sku_id = product?.product_info.product_sku_id;
  copyDataItem.product_category_info = product?.product_category_info;
  copyDataItem.available_qty = product?.available_qty;
  copyDataItem.product_sku_info = product?.product_info;
  copyDataItem.product_sku_name = product?.product_info.product_sku_name;
  copyDataItem.consumption_quantity = 1;
  copyDataItem.unitPrice = Number(product?.selling_price || 0);
  copyDataItem.quantity = 1;
  copyDataItem.uom_info = product?.product_info?.uom_info;
  copyDataItem.uomId = product?.product_info?.uom_id;
  copyDataItem.uomInfo = product?.product_info?.uom_info;
  copyDataItem.uom_list = product?.product_info?.uom_list;
  copyDataItem.uomGroup = product?.product_info?.group_id;
  copyDataItem.taxInfo = tenantSku?.tax_info;
  copyDataItem.taxId = product?.product_info?.tax_id;
  copyDataItem.batchConsumptionMethod = product?.default_outwards_method || Helpers.getBatchMethod(product);
  copyDataItem.product_batches = pBatches;
  copyDataItem.bundle_products = product?.bundle_products?.map((item) => {
    const lineKey = uuidv4();
    return {
      ...item,
      key: lineKey,
      parentKey,
      uom_info: item?.bundle_uom_info,
      taxId: Number(item?.tax_info?.tax_id),
      taxInfo: item?.tax_info,
      product_sku_name: item?.product_info?.product_sku_name,
      product_sku_id: item?.product_info.product_sku_id,
      quantity: item?.bundle_quantity,
      expiry_days: item?.product_info?.expiry_days,
      product_sku_info: item?.product_info,
      batchConsumptionMethod: item?.default_outwards_method || Helpers.getBatchMethod(item),
      product_batches: getBatches(item?.product_batches, item?.bundle_quantity, item?.bundle_uom_info, item?.product_info?.uom_info, null, lineKey),
    };
  });
  copyDataItem.manufacturingDateFormat = product?.product_info?.manufacturing_date_format;
  copyDataItem.expiryDateFormat = product?.product_info?.expiry_date_format;

  return copyDataItem;
};

export const handleProductChangeHelper = (state, props, tenantSku, key, productData, setState) => {
  const { data, tenantDepartmentId, selectedTenant } = state;
  const { user, getProductById } = props;
  getProductById((selectedTenant), tenantSku?.product_sku_id, tenantDepartmentId, (product) => {
    if (product?.product_type === 'BUNDLE' && product?.bundle_products?.length === 0) {
      notification.open({
        message:
          'This product is a bundle but it does not have any child components.',
        duration: 4,
        type: 'error',
        placement: 'top',
      });
    } else {
      const copyData = JSON.parse(JSON.stringify(data));
      for (let i = 0; i < copyData?.length; i++) {
        if (copyData[i].key === key) {
          const copyDataItem = createDefaultRow({
            dataLine: copyData[i], product, tenantSku, productData,
          });

          copyData[i] = copyDataItem;
        }
      }

      setState({ data: copyData });
    }
  }, true);
};

export const handleMultiProductChangeHelper = (state, props, tenantSku, productData, setState) => {
  const {
    data, tenantDepartmentId, cfConsumptionOrderLine, selectedTenant,
  } = state;
  const { user, getProductById } = props;

  const productSkuIds = tenantSku?.map((item) => item?.product_info?.product_sku_id)?.join(',');

  getProductById((selectedTenant), '', tenantDepartmentId, (products) => {
    const copyData = [];
    products.forEach((product) => {
      if (product?.product_type === 'BUNDLE' && product?.bundle_products?.length === 0) {
        notification.open({
          message:
            'This product is a bundle but it does not have any child components.',
          duration: 4,
          type: 'error',
          placement: 'top',
        });
      } else {
        const tenantSkuData = tenantSku?.find((item) => item?.product_info?.product_sku_id === product?.product_info?.product_sku_id);
        const productSkuData = productData?.find((item) => item?.product_sku_id === product?.product_info?.product_sku_id);

        const newDataLine = {
          key: uuidv4(),
          lineCustomFields: cfConsumptionOrderLine,
        };

        const copyDataItem = createDefaultRow({
          dataLine: newDataLine, product, tenantSku: tenantSkuData, productData: productSkuData,
        });

        copyData.push(copyDataItem);
      }
    });
    setState(copyData);
  }, true, productSkuIds);
};

export const addNewRowHelper = (state, props, callback, setState) => {
  const { data, cfConsumptionOrderLine } = state;
  const copyData = JSON.parse(JSON.stringify(data));
  const key = uuidv4();
  copyData.push({
    key,
    product_sku_name: '',
    product_sku_id: '',
    quantity: '',
    uom_info: '',
    batchConsumptionMethod: '',
    product_batches: [],
    consumption_quantity: '',
    lineCustomFields: cfConsumptionOrderLine,
  });
  setState({ data: copyData }, () => {
    if (callback) {
      callback(key);
    }
  });
};

export function customInputChangeHelper(state, props, fieldValue, cfId, setState) {
  const { cfConsumptionOrderDoc } = state;
  const newCustomField = cfConsumptionOrderDoc.map((customField) => {
    if (customField?.cfId === cfId) {
      if (customField?.fieldType === 'ATTACHMENT') {
        return {
          ...customField,
          fieldValue: fieldValue?.map((attachment) => ({
            url: attachment?.response?.response?.location || attachment?.url,
            type: attachment.type,
            name: attachment.name,
            uid: attachment.uid,
          })),
        };
      }
      return {
        ...customField,
        fieldValue,
      };
    }
    return {
      ...customField,
    };
  });
  setState({
    cfConsumptionOrderDoc: newCustomField,
  });
}

export function handleQuantityChangeHelper(record, value, freeValue, showFreebie, state, props, setState) {
  const { data, allStock } = state;
  const copyData = JSON.parse(JSON.stringify(data));

  if (record?.bundle_products?.length) {
    const bundleProducts = JSON.parse(JSON.stringify(record?.bundle_products));
    for (let i = 0; i < bundleProducts?.length; i++) {
      bundleProducts[i].product_batches = getBatches(bundleProducts[i]?.product_batches, (Number(value) + Number(freeValue)) * bundleProducts[i]?.bundle_quantity, bundleProducts[i]?.uom_info, bundleProducts[i]?.product_sku_info?.uom_info, null, bundleProducts[i]?.key, true, allStock);
    }
    const updatedData = copyData.map((obj) => {
      if (obj.key === record.key) {
        return {
          ...obj,
          consumption_quantity: value || '',
          // packed_free_quantity: freeValue || '',
          bundle_products: bundleProducts,
        };
      }
      return obj;
    });
    setState({
      data: updatedData,
    });
  } else {
    const updatedData = copyData.map((obj) => {
      if (obj.key === record.key) {
        return {
          ...obj,
          consumption_quantity: value,
          // packed_free_quantity: freeValue || '',
          product_batches: getBatches(record?.product_batches, (Number(value || 0) + Number(freeValue || 0)), record?.uom_info, record?.product_sku_info?.uom_info, null, record?.key, true, allStock),
          showFreebie,
        };
      }
      return obj;
    });
    setState({
      data: updatedData,
    });
  }
}

export const customLineInputChangeHelper = (state, props, fieldValue, key, setState) => {
  const { data } = state;
  const copyData = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < copyData.length; i++) {
    if (copyData[i]?.key === key) {
      copyData[i].lineCustomFields = fieldValue;

      const record = copyData[i];

      if (record?.bundle_products?.length) {
        const bundleProducts = JSON.parse(JSON.stringify(record?.bundle_products));
        for (let i = 0; i < bundleProducts?.length; i++) {
          bundleProducts[i].product_batches = getBatches(bundleProducts[i]?.product_batches, (Number(record?.consumption_quantity || 0) + Number(record?.packed_free_quantity || 0)) * bundleProducts[i]?.bundle_quantity, bundleProducts[i]?.uom_info, bundleProducts[i]?.product_sku_info?.uom_info, null, bundleProducts[i]?.key, true);
        }
        copyData[i].bundle_products = bundleProducts;
      } else {
        const pBatches = getBatches(record?.product_batches, (Number(record?.consumption_quantity || 0) + Number(record?.free_quantity || 0)), record?.uom_info, record?.product_sku_info?.uom_info, null, record?.key, true);
        copyData[i].product_batches = pBatches;
      }
    }
    setState({ data: copyData });
  }
};

const getSOStatus = (withApproval, props) => {
  const { orgStatusSalesOrder } = props;
  const status = {};
  if (withApproval) {
    const requiredStatus = orgStatusSalesOrder?.statuses?.filter((soStatus) => soStatus?.type === 'CONFIRMED' && soStatus?.is_default === true)?.[0];
    status.custom_status_id = requiredStatus?.custom_status_id;
    status.secondary_status = requiredStatus?.status_name;
  } else {
    const requiredStatus = orgStatusSalesOrder?.statuses?.filter((soStatus) => soStatus?.type === 'DRAFT' && soStatus?.is_default === true)?.[0];
    status.custom_status_id = requiredStatus?.custom_status_id;
    status.secondary_status = requiredStatus?.status_name;
  }
  return status;
};

export const createConsumptionOrderHelper = (state, props, withApproval, errors, setState) => {
  setState({ withApproval });
  const {
    createInvoice, history, user, callback, createTag, selectedAMCForConsumption,
  } = props;
  const {
    data, terms, termsAndConditions, selectedCustomer, coNumber, invoiceDate, selectedTenant, attachments,
    selectedCustomerInfo, gstNumber, tenantDepartmentId, description, initialCoNumber, docSeqId,
    salesAccount, accountManager, customVoucherNumber, selectedTags, cfConsumptionOrderDoc, currentSelectedTenantInfo, shipToAddress, shipFromAddress,
  } = state;
  const consumptionOrderLine = [];
  const { docLevelError, lineLevelError } = errors;
  const getInvoiceLineBatches = (batches, manufacturingDateFormat, expiryDateFormat) => {
    const invoiceBatches = [];
    for (let j = 0; j < batches?.length; j++) {
      if (batches[j]?.batch_in_use && batches[j]?.consumed_qty > 0) {
        invoiceBatches.push({
          batch_id: batches[j]?.batch_id,
          quantity: batches[j]?.consumed_qty,
          inventory_location_id: batches[j]?.inventory_location_id,
          is_rejected_batch: batches[j]?.is_rejected_batch,
          manufacturing_date: batches?.[j]?.manufacturing_date ? FormHelpers.dateFormatter(batches?.[j]?.manufacturing_date, manufacturingDateFormat) : null,
          expiry_date: batches?.[j]?.expiry_date ? FormHelpers.dateFormatter(batches?.[j]?.expiry_date, expiryDateFormat) : null,
        });
      }
    }
    return invoiceBatches;
  };
  setState({ formSubmitted: true });
  if (isDataValid(state, props, { docLevelError, lineLevelError })) {
    for (let i = 0; i < data?.length; i++) {
      const consumptionOrderLineObj = {
        default_outwards_method: data[i]?.batchConsumptionMethod,
        tenant_product_id: data?.[i]?.tenant_product_id,
        custom_fields: CustomFieldHelpers.postCfStructure(data[i]?.lineCustomFields),
        quantity: Number(data[i].consumption_quantity),
        product_sku_name: data[i].product_sku_name,
        uom_info: [data[i]?.uom_info],
        uom_id: data[i]?.uom_info?.uom_id,
        product_batches: data[i]?.product_sku_info?.product_type === 'STORABLE' ? getInvoiceLineBatches(data?.[i]?.product_batches, data?.[i]?.manufacturingDateFormat, data?.[i]?.expiryDateFormat) : [],
        bundle_products: data[i]?.bundle_products?.map((item) => ({
          tenant_product_id: item?.tenant_product_id,
          uom_info: [item?.uom_info],
          quantity: Number(data[i].consumption_quantity * item?.bundle_quantity),
          product_sku_name: item?.product_sku_name,
          uom_id: item?.uom_info?.uom_id,
          product_batches: getInvoiceLineBatches(item?.product_batches, data?.[i]?.manufacturingDateFormat, data?.[i]?.expiryDateFormat),
          default_outwards_method: item?.batchConsumptionMethod,
        })),
        order_line_id: data[i]?.order_line_id,
        remarks: data[i]?.remarks || '',
      };
      consumptionOrderLine.push(consumptionOrderLineObj);
    }
    const payload = [{
      invoice_type: 'CONSUMPTION_ORDER',
      tenant_department_id: selectedAMCForConsumption ? selectedAMCForConsumption?.tenant_department_id : tenantDepartmentId,
      customer_id: selectedCustomer,
      remarks: description,
      invoice_lines: consumptionOrderLine,
      tenant_id: selectedAMCForConsumption ? selectedAMCForConsumption?.tenant_id || selectedAMCForConsumption?.tenant_info?.tenant_id : selectedTenant,
      invoice_date: dayjs(invoiceDate).format('YYYY/MM/DD'),
      customer_info: { ...selectedCustomerInfo, gst_number: gstNumber },
      tenant_info: selectedAMCForConsumption ? selectedAMCForConsumption?.tenant_info : {
        tenant_name: currentSelectedTenantInfo?.tenant_name,
        legal_name: currentSelectedTenantInfo?.legal_name,
        gst_number: currentSelectedTenantInfo?.gst_number,
      },
      attachments: attachments?.map((attachment) => ({
        url: attachment?.response?.response?.location || attachment?.url,
        type: attachment.type,
        name: attachment.name,
        uid: attachment.uid,
      })) || [],
      status: withApproval ? 'CONFIRMED' : 'DRAFT',
      terms_and_conditions: global.isBlankString(termsAndConditions) ? '' : termsAndConditions,
      custom_fields: CustomFieldHelpers.postCfStructure(cfConsumptionOrderDoc),
      invoice_number: initialCoNumber?.toLowerCase()?.trim() === coNumber?.toLowerCase()?.trim() ? null : coNumber,
      seq_id: docSeqId || null,
      secondary_status: getSOStatus(state, props, withApproval)?.secondary_status,
      custom_status_id: getSOStatus(state, props, withApproval)?.custom_status_id,
      account_manager_id: accountManager || null,
      source: selectedAMCForConsumption?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? 'ANNUAL_MAINTENANCE_CONTRACT' : '',
      order_id: selectedAMCForConsumption?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? selectedAMCForConsumption?.order_id : null,
      shipping_address_info: shipToAddress,
      shipping_address: shipToAddress?.address_id,
      ship_from_address_info: shipFromAddress,
      ship_from_address_id: shipFromAddress?.address_id,
    }];
    createInvoice(payload, (invoice) => {
      setState({ currentAction: '' });
      if (selectedTags?.length) {
        const tagPayload = {
          entity_name: 'INVOICE',
          entity_id: invoice?.invoice_id,
          action: 'ADD',
          tag: selectedTags.join(','),
        };
        createTag(tagPayload, () => {
          history.push(`/sales/consumption/view/${invoice?.invoice_id}`);
        });
      }
      if (callback) {
        callback();
      } else {
        history.push(`/sales/consumption/view/${invoice?.invoice_id}`);
      }
    });
  } else {
    notification.open({
      type: 'error',
      duration: '5',
      message: 'Please provide input for all mandatory fields',
      placement: 'top',
    });
  }
};

export const updateBatchValueHelper = (record, value, label, batchId, state, props, setState) => {
  const { data, allStock } = state;

  const copyData = JSON.parse(JSON.stringify(data));
  const updatedData = copyData.map((obj) => {
    if (obj.key === record?.key) {
      let productBatches = obj?.product_batches;
      productBatches = productBatches?.map((productBatch) => {
        if (productBatch.batch_id === batchId) {
          if (label === 'consumed_qty') {
            const avlQty = QUANTITY((Number(productBatch?.available_qty) / obj?.uom_info?.ratio) * obj?.product_sku_info?.uom_info?.ratio, obj?.uom_info?.precision);
            return {
              ...productBatch,
              [label]: value > avlQty ? avlQty : value,
            };
          }
          return {
            ...productBatch,
            [`${label}`]: value,
          };
        }
        return productBatch;
      });

      // const qty = productBatches.reduce((sum, batch) => sum + (Number(batch.consumed_qty) || 0), 0);
      const qty = productBatches.reduce(
        (sum, batch) => sum.plus(new Decimal(batch.consumed_qty || 0)),
        new Decimal(0)
      );

      return {
        ...obj,
        // product_batches: productBatches,
        product_batches: getBatches(productBatches, (Number(qty || 0) + Number(obj.packed_free_quantity || 0)), obj?.uom_info, obj?.product_sku_info?.uom_info, null, obj?.key, true, allStock, batchId, value || 0),
        consumption_quantity: qty,
      };
    }
    return obj;
  });

  setState({ data: updatedData });
};
